import { render, staticRenderFns } from "./cardPerson.vue?vue&type=template&id=5fee1a12&scoped=true"
import script from "./cardPerson.vue?vue&type=script&lang=js"
export * from "./cardPerson.vue?vue&type=script&lang=js"
import style0 from "./cardPerson.vue?vue&type=style&index=0&id=5fee1a12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fee1a12",
  null
  
)

export default component.exports